import * as React from "react";
import { PasswordInput } from "../../../../form"
import { Input, Form } from "antd";
const FormItem = Form.Item;

class FtpOption extends React.Component<any, {}> {
  render() {
    const {
      getFieldDecorator
    } = this.props.form;

    const { option, disabled } = this.props;

    /*
     * NOTE: validation requires a unique key as identifier for the field
     * thus we create one with `${option}.name`. However then this causes
     * our callback's event.target to have no name. We also append the
     * `name prop to all our input fields.
     */
    return (
      <div className="details right">
        <Form>
          <h4>Server Info</h4>
          <div className="pure-g">
            <div className="info left pure-u-xs-1 pure-u-m-11-24 pure-u-l-11-24 pure-u-xl-11-24">
              <FormItem label="Name" hasFeedback={!disabled}>{
                getFieldDecorator(`${option}.name`, {
                  rules: [{ required: !disabled, message: "Please specify a name" }],
                  initialValue: this.props.name
                })(
                  <Input
                    className="form-length"
                    name="name"
                    disabled={disabled}
                    onChange={this.props.handleChange}
                    placeholder="My endpoint configs"
                  />
                  )
              }</FormItem>

              <FormItem label="Host Name" hasFeedback={!disabled}>{
                getFieldDecorator(`${option}.hostname`, {
                  rules: [{ required: !disabled, message: "Please specify a hostname" }],
                  initialValue: this.props.hostname
                })(
                  <Input
                    className="form-length"
                    name="hostname"
                    disabled={disabled}
                    onChange={this.props.handleChange}
                    placeholder="my.host.name"
                  />
                  )
              }</FormItem>

              <FormItem label="Port" hasFeedback={!disabled}>{
                getFieldDecorator(`${option}.port`, {
                  rules: [{ required: !disabled, message: "Please specify a port" }],
                  initialValue: this.props.port
                })(
                  <Input
                    className="form-length"
                    name="port"
                    disabled={disabled}
                    onChange={this.props.handleChange}
                    placeholder="port"
                  />
                  )
              }</FormItem>

              <FormItem label="Path" hasFeedback={!disabled}>{
                getFieldDecorator(`${option}.path`, {
                  rules: [{ required: !disabled, message: "Please specify a path" }],
                  initialValue: this.props.path
                })(
                  <Input
                    className="form-length"
                    name="path"
                    disabled={disabled}
                    onChange={this.props.handleChange}
                    placeholder="/home/path/to/file"
                  />
                  )
              }</FormItem>
            </div>

            <div className="credentials right pure-u-xs-1 pure-u-m-12-24 pure-u-l-1-2 pure-u-xl-1-2">
              <FormItem label="Username" hasFeedback={!disabled}>{
                getFieldDecorator(`${option}.username`, {
                  rules: [{ required: !disabled, message: "Please specify a username" }],
                  initialValue: this.props.username
                })(
                  <Input
                    className="form-length"
                    name="username"
                    disabled={disabled}
                    onChange={this.props.handleChange}
                    placeholder="username"
                  />
                  )
              }</FormItem>

              <FormItem label="Password" hasFeedback={!disabled} className="password" >{
                getFieldDecorator(`${option}.password`, {
                  rules: [{ required: !disabled, message: "Please specify a password" }],
                  initialValue: this.props.password
                })(
                  <PasswordInput
                    name="password"
                    disabled={disabled}
                    onChange={this.props.handleChange}
                    placeholder="********"
                  />
                  )
              }</FormItem>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

export default FtpOption as any;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/ReportEndpoint/ftp.tsx